import { forwardRef } from 'react';

import { Box } from 'ui';

import { useRemovePrintElement } from '../hooks/useRemovePrintElement';

type NotPrintProps = {
  children: React.ReactNode;
};

const NoPrintTarget = forwardRef<HTMLDivElement, NotPrintProps>(({ children, ...others }, ref) => {
  const { noPrintRef } = useRemovePrintElement({ ref });
  return (
    <Box ref={noPrintRef} {...others}>
      {children}
    </Box>
  );
});

NoPrintTarget.displayName = 'NoPrintTarget';

export { NoPrintTarget };
